import { unref } from 'vue'
import type { Ref } from 'vue'
import { useApi } from '~/api'
import { defineService } from '~/api/models/helpers'
import type { AuthArgs } from '~/api/models/index'

interface StateViewConfigArgs {
  viewKey: string
  assetTypeId: string
}

const queries = {
  getStateViewConfigs: {
    queryFn: (args: StateViewConfigArgs | Ref<StateViewConfigArgs>) => {
      const { viewKey, assetTypeId } = unref(args)
      return useApi().stateViewConfigs.getStateViewConfigs(viewKey, assetTypeId)
    },
    queryKey: (args: StateViewConfigArgs | Ref<StateViewConfigArgs>) => {
      const { viewKey, assetTypeId } = unref(args)
      return ['stateViewConfigs', viewKey, assetTypeId]
    },
    options: {
      enabled: (args: StateViewConfigArgs | Ref<StateViewConfigArgs>) => {
        const { assetTypeId } = unref(args)
        return !!assetTypeId
      }
    }
  }
} as const

const mutations = {} as const

export type StateViewConfigsModelService = ReturnType<typeof defineService<typeof queries, typeof mutations>>

export const registerService = (authArgs: AuthArgs): StateViewConfigsModelService =>
  defineService(authArgs, { queries, mutations })
